import { useContext } from 'react'
import EditContainerCloseContext from './editContainerCloseContext'

export const useEditContainerClose = (): (() => void) | null => {
  return useContext(EditContainerCloseContext)
}
